import {ApiFunction} from "../chatbot/towersChatbotApi";
import {AcestreamConnectionsResponse, AcestreamLink, LeagueEvent, StremioCatalogResponse, StremioMetaDetails, StremioStreamsResponse} from "./types";

export class TowersSportsApi {
    static baseUrl = 'https://torresowo.myftp.org:7777/twr-sports/v1/';

    // Obtener todos los usuarios
    static async getEvents() {
        const fn = new ApiFunction('getEvents', this.baseUrl);
        return fn.call({}) as Promise<{ events: LeagueEvent[] }>;
    }

    static async getTeams() {
        const fn = new ApiFunction('getTeams', this.baseUrl);
        return fn.call({});
    }

    static async getEvent(eventId: string) {
        const fn = new ApiFunction('getEventDetails', this.baseUrl);
        return fn.call({eventId}) as Promise<{ event: LeagueEvent }>;
    }

    static async getAcestreamLinks(): Promise<AcestreamLink[]> {
        const fn = new ApiFunction('getAcestreamLinks', this.baseUrl);
        return fn.call({});
    }

    static async getAcestreamChannels(): Promise<StremioCatalogResponse> {
        const response = await fetch('https://torresowo.myftp.org:7777/squadflix-plugin/catalog/other/squadflix-live-tv.json');
        const data = await response.json();
        return data as StremioCatalogResponse;
    }

    static async getAcestreamChannelById(channelId: string): Promise<StremioMetaDetails> {
        const response = await fetch(`https://torresowo.myftp.org:7777/squadflix-plugin/meta/other/${channelId}.json`);
        const data = await response.json();
        return data.meta as StremioMetaDetails;
    }

    static async getAcestreamChannelStreams(channelId: string): Promise<StremioStreamsResponse> {
        const response = await fetch(`https://torresowo.myftp.org:7777/squadflix-plugin/stream/other/${channelId}.json`);
        const data = await response.json();
        return data as StremioStreamsResponse;
    }

    static async getAcestreamActiveConnections(): Promise<AcestreamConnectionsResponse> {
        const response = await fetch(`https://torresowo.myftp.org:7777/ace-station/hls/getActiveConnections`);
        const data = await response.json();
        return data as AcestreamConnectionsResponse;
    }

}
